import React from "react";
import { Tag, Tooltip } from "antd";
import { CaretUpOutlined, CaretDownOutlined } from "@ant-design/icons";
import { adjustColor, formatAdjustAmount, formatAdjustRate } from "./priceAdjust";

/**
 * 調漲 / 調降 / 持平的幅度標籤。
 *
 * rate 為 null 時完全不渲染 —— 「沒有標籤」代表算不出調幅，
 * 必須跟「持平」這個有意義的結果分得開。
 */
export default function PriceAdjustTag({ amount, rate, style }) {
  if (rate === null || rate === undefined) return null;

  const icon =
    rate > 0 ? <CaretUpOutlined /> : rate < 0 ? <CaretDownOutlined /> : null;
  const label = rate === 0 ? "持平" : formatAdjustRate(rate);

  return (
    <Tooltip title={formatAdjustAmount(amount)}>
      <Tag style={{ marginLeft: 5, color: adjustColor(rate), ...style }}>
        {icon}
        {icon ? " " : null}
        {label}
      </Tag>
    </Tooltip>
  );
}
